﻿'use strict'

module.exports = {
	parse: require('./parse'),
	stringify: require('./stringify')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-font/index.js
// module id = vRl9
// module chunks = 0